import type { CategoryType, ServiceType } from '../../types'
import { baseApi } from '../baseApi'
import type { ITenantUser, ITenantUsersResponse, ResponseType } from '../types'

const webBase = 'api/tenants'

export const webPageApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllUsers: builder.query<
            ResponseType<ITenantUsersResponse[]>,
            string
        >({
            query: (qwery) => `${webBase}/users?${qwery}`,
            providesTags: ['tenantUser'],
        }),
        getUserById: builder.query<ResponseType<ITenantUser>, number | string>({
            query: (id) => `${webBase}/users/${id}`,
        }),

        createUser: builder.mutation<ResponseType<any>, FormData>({
            query: (body) => ({
                url: `api/auth/register-user`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['tenantUser'],
        }),
        deleteUser: builder.mutation<ResponseType<any>, number | string>({
            query: (id) => ({
                url: `${webBase}/users/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['tenantUser'],
        }),
        updateUser: builder.mutation<
            ResponseType<ITenantUser>,
            { id: string; body: FormData }
        >({
            query: ({ id, body }) => ({
                url: `${webBase}/users/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['tenantUser'],
        }),
    }),
})

export const {
    useLazyGetAllUsersQuery,
    useGetAllUsersQuery,
    useGetUserByIdQuery,
    useCreateUserMutation,
    useDeleteUserMutation,
    useUpdateUserMutation,
} = webPageApi
